const DATA_TYPES = {
  item: 'item',
  shopDishesItem: 'shopDishesItem',
};

export default DATA_TYPES;
